import { get } from 'lodash';
import { browserHistory } from 'react-router';
import { history } from '../../history';
import {
  REQUEST_BARBERS,
  RECEIVE_BARBERS,
  REQUEST_BARBER_AVAILABLE_TIME,
  RECEIVE_BARBER_AVAILABLE_TIME,
} from '../constants';
import {
  checkStatus,
  handleRequestError,
  checkRoute,
  joinQueryStringParams,
} from '../utils/helpers';
import config from '../../config';
import { getBarbersCount } from './selectors';

function requestBarbers() {
  return { type: REQUEST_BARBERS };
}

export function receiveBarbers(barbers) {
  return {
    type: RECEIVE_BARBERS,
    payload: barbers,
  };
}

const appendPrefix = (path, prefix) => {
  if (!prefix) {
    return path;
  }
  return `/${prefix}${path}`;
};

const redirectIfOldRoute = (oldRoute, kiosk, book) => (barbers) => {
  const route = get(barbers, '[0].shop.route');
  if (route && oldRoute !== route) {
    let path = browserHistory.getCurrentLocation().pathname.split('/');

    const consolidatedPrefix = config.pathPrefix.replace(/^\/|\/$/g, '').split('/').join('/');
    if (consolidatedPrefix) {
      const regexp = new RegExp(`^/${consolidatedPrefix}`);
      path = browserHistory.getCurrentLocation().pathname.replace(regexp, '').split('/');
    }

    path.splice(0, 3);
    if (kiosk !== -1) history.replace(appendPrefix(`/kiosk/${route}/${path.join('/')}`));
    else if (book !== -1) history.replace(appendPrefix(`/book/${route}/${path.join('/')}`));
    else history.replace(appendPrefix(`/${route}`));
  }
  return barbers;
};

export function fetchBarbers(shopRoute, params, urlPattern) {
  return (dispatch, getState) => {
    if (!shopRoute) return Promise.resolve();
    if (getBarbersCount(getState(), { shopRoute }) > 0) return Promise.resolve();

    dispatch(requestBarbers());

    const includes = 'include=photos,shop,services,days_on,reward&limit=100&sortBy=order:asc,createdAt:desc';
    const url = `${config.url}/shop/${shopRoute}/barber/?${includes}`;

    const pattern = urlPattern && urlPattern.search ? urlPattern : params;

    // -1 is what .search returns if nothing is found
    let [kiosk, book] = [-1, -1];
    if (pattern && pattern.search) {
      kiosk = pattern.search('kiosk');
      book = pattern.search('book');
    }

    return fetch(url)
      .then(checkRoute(dispatch, params, urlPattern))
      .then(checkStatus)
      .then(redirectIfOldRoute(shopRoute, kiosk, book))
      .then(barbers => dispatch(receiveBarbers(barbers, params)))
      .catch(error => Promise.reject(error));
  };
}

const transformBrandBarbers = barbers => (
  barbers.map(barber => ({
    ...barber,
    route: barber.shops[0].barberId,
    id: barber.shops[0].barberId,
  }))
);

export function fetchBrandBarbers(brandId, params, urlPattern) {
  return (dispatch) => {
    if (!brandId) return Promise.resolve();

    dispatch(requestBarbers());

    return fetch(`${config.url}/brand/${brandId}/barber`)
      .then(checkRoute(dispatch, params, urlPattern))
      .then(checkStatus)
      .then(transformBrandBarbers)
      .then(barbers => dispatch(receiveBarbers(barbers, params)))
      .catch(error => Promise.reject(error));
  };
}

function shouldFetchBarberAvailableTime(state, id) {
  return !state.barbers.get('items').find(barber => barber.get('id') === id && barber.get('nextTime'));
}

function requestBarberAvailableTime(id) {
  return {
    type: REQUEST_BARBER_AVAILABLE_TIME,
    payload: id,
  };
}

function receiveBarberAvailableTime(id, nextTime) {
  return {
    type: RECEIVE_BARBER_AVAILABLE_TIME,
    payload: { id, nextTime },
  };
}

function fetchBarberNextAvailableTime(barber, serviceDuration, kiosk, shopRoute) {
  const id = barber.get('id');
  return (dispatch, getState) => {
    if (!shouldFetchBarberAvailableTime(getState(), id)) return Promise.resolve();

    dispatch(requestBarberAvailableTime(id));

    const params = joinQueryStringParams([
      kiosk ? 'kiosk=true' : '',
    ]);
    const durationString = serviceDuration ? `/${serviceDuration}` : '';
    const url = `${config.url}/shop/${shopRoute}/barber/${id}/next-available-time${durationString}${params}`;

    return fetch(url)
      .then(checkStatus)
      .then(({ time }) => dispatch(receiveBarberAvailableTime(id, time)))
      .catch(handleRequestError(dispatch));
  };
}

export function fetchBarbersWithNextAvailableTime(shopRoute, params, urlPattern, serviceDuration, kiosk) {
  return (dispatch, getState) =>
    dispatch(fetchBarbers(shopRoute, params, urlPattern))
      .then(() => Promise.all(
        getState().barbers.get('items').map(
          barber => dispatch(fetchBarberNextAvailableTime(barber, serviceDuration, kiosk, shopRoute))
        ))
      )
      .catch(handleRequestError(dispatch));
}



// WEBPACK FOOTER //
// ./src/app/barbers/actions.js